import * as React from "react";
import "./LeadStatusStepper.css";
import LeadStatusStepperRow from "./LeadStatusStepperRow";
import { AllLeadsStatusStepper } from "../../FetchAPI";
import axios from "axios";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
import { useAuth } from "../../../Store/AuthContext";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function LeadStatusStepper({
  leadID,
  servicID,
  detailsStatusID,
  triggerRefresh,
}) {
  const { RendomTokenfetch, userID, userRoll } = useAuth();

  const [checkedSteps, setCheckedSteps] = React.useState([]);
  const [LeadstatuStepper, setLeadstatuStepper] = React.useState([]);
  const LengthStepper = LeadstatuStepper.length;
  const [loading, setLoading] = React.useState(false);
  const FetchVendorLeads = React.useCallback(async () => {
    try {
      setLoading(true);
      const data = await AllLeadsStatusStepper(
        RendomTokenfetch,
        leadID,
        servicID
      );
      setLeadstatuStepper(data);
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, leadID, servicID]);

  React.useEffect(() => {
    FetchVendorLeads();
  }, [FetchVendorLeads, leadID, servicID]);

  React.useEffect(() => {
    if (Array.isArray(LeadstatuStepper)) {
      setCheckedSteps(LeadstatuStepper.map((step) => step.dataset === 1));
    }
  }, [LeadstatuStepper]);

  const handleStatusChange = (statusid) => async (event) => {
    if (userRoll !== "4") return;
    if (statusid !== detailsStatusID) return;

    const index = LeadstatuStepper.findIndex(
      (step) => step.statusid === statusid
    );
    if (index === -1) return;

    if (!checkedSteps[index]) {
      const confirmClaim = window.confirm(
        "Are you sure you want to Accept this lead?"
      );
      if (!confirmClaim) return;
    }

    const newCheckedSteps = [...checkedSteps];
    newCheckedSteps[index] = true;
    setCheckedSteps(newCheckedSteps);

    let fdata = new FormData();
    fdata.append("role_id", userRoll);
    fdata.append("userid", userID);
    fdata.append("leadid", leadID);
    fdata.append("status_id", statusid);

    try {
      setLoading(true);
      const response = await axios.post(
        `${WebsiteAPIurl}vendorleadstatusupdate`,
        fdata,
        {
          headers: {
            Authorization: RendomTokenfetch,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log(response.data);
      if (response.data.Status === "1") {
        NotifyMessageNoReload(response.data.message, "success");
        FetchVendorLeads();
        if (triggerRefresh) {
          triggerRefresh();
        }
        // navigate(`/lead-working-details/${leadID}`);
      } else {
        NotifyMessageNoReload(response.data.message, "danger");
      }
    } catch (error) {
      console.error("Error Lead:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }
  return (
    <div className="StepperBox">
      <div className="leadStatusBox">
        {Array.isArray(LeadstatuStepper) && LeadstatuStepper.length > 0 ? (
          LeadstatuStepper.map((value, index) => (
            <LeadStatusStepperRow
              key={index}
              statusName={value.status}
              completestatus={value.completestatus}
              cruntstatus={value.cruntstatus}
              completedate={value.completedate}
              dataset={value.dataset}
              stapeCountID={index}
              StepperLength={LengthStepper}
              isChecked={checkedSteps[index] ?? false}
              handleCheckbox={handleStatusChange(value.statusid)}
              detailsStatusID={detailsStatusID}
              isDisabled={
                userRoll !== "4" && value.statusid !== detailsStatusID
              }
            />
          ))
        ) : (
          <p>No steps available</p>
        )}
      </div>
    </div>
  );
}
